import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useSettingsStore } from "./store";
import { Button, Form, Input, Radio, Row } from "antd";
import { settingKeyOptions } from "modules/utilities/utility";

function EditModal({ modalShow, setModalShow, settingKey }) {
  const [form] = Form.useForm();
  const { setToaster } = useToast();
  const [loading, setLoading] = useState(false);
  const [dataKey, setDataKey] = useState("");
  const [valueType, setValueType] = useState("");
  const [message, setMessage] = useState("");

  const { fetchSettingsData, addLoading, addSettings } = useSettingsStore();

  useEffect(() => {
    if (!modalShow) return;
    form.setFieldsValue({
      key: settingKey.key,
      value: settingKey.value,
    });
  }, [form, modalShow, settingKey]);

  useEffect(() => {
    if (
      settingKey.key === "is_sms_notification_enabled" ||
      settingKey.key === "WAREHOUSE_ALLOCATION"
    ) {
      setDataKey(settingKey.key);
    }
  });

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage(null);
      }, 1500);
    }
  }, [message]);

  const handleModalClose = () => {
    form.resetFields();
    setModalShow(false);
  };

  const onSubmit = async (settingKey) => {
    addOneProductData(
      settingKey,
      setToaster,
      fetchProductsData,
      handleModalClose
    );
  };

  const handleValueTypeChange = ({ target }) => {
    setValueType(target.value);
  };

  const handleSubmit = async (value) => {
    setLoading(true);
    let isValueCheck = false;
    if (
      settingKey.key === "EXOTEL_CALLERID" ||
      settingKey.key === "EXOTEL_POST_SALES_CALLERID"
    ) {
      if (value.value.length > 10 && value.value.length <= 11) {
        if (value.value.substring(0, 1) == "0") {
          isValueCheck = true;
        }
      } else if (value.value.length > 9 && value.value.length < 11) {
        isValueCheck = true;
      } else {
        isValueCheck = false;
        setMessage("Please enter valid number");
      }
    } else {
      isValueCheck = true;
    }

    if (isValueCheck) {
      const key = settingKey.key;
      addSettings(
        { key, value: dataKey ? valueType : value.value },
        setToaster,
        fetchSettingsData,
        handleModalClose
      );
    }
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div>Edit Values</div>
          {message ? <div>{message}</div> : null}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form form={form} onFinish={handleSubmit}>
          {settingKey?.key !== dataKey && (
              <Form.Item
                  label="Value"
                  name="value"
                  rules={
                    settingKeyOptions.includes(settingKey.key)
                        ? [
                          { required: true, message: "Please enter your value" },
                          { whitespace: true, message: "Please enter a valid value" },
                          // You can add custom patterns if needed in future, but for now, this will accept anything
                        ]
                        : [
                          { required: true, message: "Please enter a value" },
                          { whitespace: true, message: "Please enter a valid value" },
                        ]
                  }
              >
                <Input placeholder={settingKey.value} />
              </Form.Item>
          )}

          <br />
          {settingKey?.key === dataKey && (
            <Row justify="center" style={{ marginBottom: 20 }}>
              <Radio.Group
                optionType="button"
                buttonStyle="outline"
                size="large"
                onChange={handleValueTypeChange}
                value={valueType}
              >
                <Radio
                  buttonStyle="solid"
                  value="true"
                  style={{
                    fontSize: 17,
                  }}
                >
                  True
                </Radio>
                <Radio
                  value="false"
                  buttonStyle="solid"
                  style={{
                    fontSize: 17,
                  }}
                >
                  False
                </Radio>
              </Radio.Group>
            </Row>
          )}

          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              className="float-end"
              loading={addLoading}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setModalShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditModal;
